module.exports = __webpack_public_path__ + "img/FAQ_Desktop.6d8cc6f4.svg";